import { connect } from 'react-redux'
import React, { Component } from 'react'
import FontAwesome from 'react-fontawesome'
import numeral from 'numeral'
import moment from 'moment'

import {
    formatcoin
} from '../../utils/helpers'


import BoxSection from '../Layout/BoxSection'

class AttachedAdicionalsBox extends Component {
    render() {
        const { adiciones, divisa } =this.props

        if (adiciones.count() === 0) {
            return (
                <div style={{ textAlign: 'center', color: '#bbb' }}>
                    <h3><FontAwesome name="exclamation-circle" /> No han sido agregadas adiciones a este documento</h3>
                </div>
            )
        }
                
        return  adiciones.map((a, b) => {
            return (
                <div key={`bs19[${b}]`}>
                    { (b > 0 && <div className="separator" />) }
                    <BoxSection title={ `Ajuste #${b + 1}` }>
                        <table className="table table-condensed table-bordered table-striped">
                            <thead>
                                <tr>
                                    <th colSpan={4}>Descripción</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td colSpan={4}>{ a.getIn(['detalles', '0', 'descripcion']) }</td>
                                </tr>
                            </tbody>
                            <thead>
                                <tr>
                                    {/* <th>Cantidad</th> */}
                                    <th>Valor sin IVA</th>
                                    <th>Valor Total</th>
                                    <th colSpan={2}>Fecha Entrega</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    {/* <td style={{ textAlign: 'right' }}>{ a.getIn(['detalles', '0', 'cantidad']) }</td> */}
                                    <td style={{ textAlign: 'right' }}>{ formatcoin((a.getIn(['detalles', '0', 'cantidad']) * a.getIn(['detalles', '0', 'valor'])),divisa.simbolo) }</td>
                                    <td style={{ textAlign: 'right' }}>{ formatcoin((a.getIn(['detalles', '0', 'cantidad']) * a.getIn(['detalles', '0', 'valor_con_iva'])),divisa.simbolo) }</td>
                                    <td style={{ textAlign: 'right' }} colSpan={2}>{ moment(a.get('fecha')).format('YYYY-MM-DD') }</td>
                                </tr>
                            </tbody>
                            <thead>
                                <tr>
                                    <th colSpan={4}>Distribución en cencos</th>
                                </tr>
                                <tr>
                                    <th>Código</th>
                                    <th>Descripción</th>
                                    <th>Porcentaje</th>
                                    <th>Valor</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    a.getIn(['detalles', '0', 'cencos']).map((c, d) => {
                                        return (
                                            <tr key={`tr20[${c.get('id')}]`}>
                                                <td>{ c.get('codigo') }</td>
                                                <td>{ c.get('descripcion') }</td>
                                                <td style={{ textAlign: 'right' }}>{ numeral(Number(c.getIn(['pivot', 'porcentaje'])) / 100).format('0.0%') }</td>
                                                <td style={{ textAlign: 'right' }}>{ formatcoin(((Number(c.getIn(['pivot', 'porcentaje'])) / 100) * (a.getIn(['detalles', '0', 'cantidad']) * a.getIn(['detalles', '0', 'valor_con_iva']))),divisa.simbolo) }</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </BoxSection>
                </div>
            )
        })
    }
}


const mapStateToProps = (state) => {
    return {
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AttachedAdicionalsBox)



// WEBPACK FOOTER //
// ./src/components/Documentos/AttachedAditionalsBox.jsx